import Reflux from "reflux";

export default Reflux.createActions({
  initQueue: { sync: false },
  startQueue: { sync: false },
  pauseQueue: { sync: true },
  stopQueue: { sync: true },
  finishQueue: { sync: true }
});
